const GridPoints = ({ gridDataArray }) => {
    return (
        <>
            <div className="grid grid-cols-1 grid-rows-1">
                <dl className="grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-3 sm:gap-y-5 lg:gap-x-8">
                    {gridDataArray.map((grid) => (
                        <div key={grid.id} className="border-t border-gray-200 pt-2">
                            <dt className="font-medium text-gray-900">{grid.id}. {grid.title}</dt>
                            <dd className="mt-2 text-sm text-gray-500 whitespace-pre-line">{grid.description}</dd>
                        </div>
                    ))}
                </dl>
            </div>
        </>
    )
}

export default GridPoints